<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      西乡桃源站<br>
站点介绍<br>
西乡桃源站位于前进二路和航城大道交叉口，沿前进二路南北向布置。周边主要分布了桃源居中澳实验学校、桃源居 社区、领航城、御品峦山花园等多个项目,是宝安片区文创、教育、居住、商业、工业、城市综合体集中区域，客流较为集中，片区出行需求量较大。车站为地下站，地下一层为站厅层，地下二层为站台层，车站设有自动扶梯、垂梯、公共洗手间等便民设施。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:44	23:40	12号线	4分钟	8分钟<br>
海上田园东	06:08	23:32	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:48	23:40	12号线	8分钟	8分钟<br>
海上田园东	06:09	23:32	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
A出入口:<br>
桃源居中澳实验学校大门南侧<br><br>
B出入口:<br>
桃源居中澳实验学校大门北侧、桃源居三区<br><br>
C出入口:<br>
新安实业有限公司第三工业园、领航城<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 西乡交管所 1 站<br>
395 路、707 路、e36 路、 m210 路、m246 路、m350 路 、m355 路、高峰专 线 31 路、高快巴士 47 号<br><br>
B出入口:<br>
公交站名： 宝安桃源居站<br>
395 路、e36 路、 m210 路、m246 路、m350 路 、m355 路、高峰专线 31 路、 高快巴士 47 号、603 路、e23 路、m250 路、727 路、m358 路、m470 路<br><br>
C出入口:<br>
公交站名： 桃源居中澳学校站<br>
m470 路<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>